/**
 * Basic JavaScript helper functions.
 *
 * @module js
 * @author EN GARDE (Martin Holler, David Hell)
 * @version 1.1
 */

import _ from 'lodash';

/**
 * Decodes a query string (i.e. foo=bar&foo[]=bar&foo[]=baz) to an object
 * @param {string} queryString
 * @return {object}
 */
export function deserializeQueryString(queryString) {
	var keys = [];
	var values = [];
	var counters = {};
	var replaceKeyIndex = function (needle, position, haystack) {
		var index = haystack.substr(0, position);
		counters[index] = counters[index] + 1 || 0;

		return '[' + counters[index] + ']';
	};

	_.each(queryString.split('&'), function (parameterString) {
		var pair = parameterString.split('=');
		var key = decodeURIComponent(pair[0]);
		var value = pair[1] ? decodeURIComponent(pair[1]) : ''; // '' is to mimic PHPs $_GET

		// continue if the variable name is empty (e.g. "=value")
		if (!key) {
			return;
		}

		key = key.replace(/\[\]/g, replaceKeyIndex);

		keys.push(key);
		values.push(value);
	});

	return _.zipObjectDeep(keys, values);
}

/**
 * Encodes an object as a query string (i.e. foo=bar&foo[]=bar&foo[]=baz).
 * @param {object} object
 * @return {string}
 * @requires jQuery.param
 */
export function serializeQueryString(object) {
	object = object || {};

	var parameters = decodeURIComponent($.param(object));

	return parameters;
}

/**
 * Quote regular expression characters
 * JavaScript equivalent of PHPs preg_quote
 * @param {string} str The input string.
 * @param {string} delimiter If the optional delimiter is specified, it will also be escaped.
 * @link http://php.net/manual/en/function.preg-quote.php
 */
export function pregQuote(str, delimiter) {
	//  discuss at: http://phpjs.org/functions/preg_quote/
	// original by: booeyOH
	// improved by: Ates Goral (http://magnetiq.com)
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// bugfixed by: Onno Marsman
	//   example 1: preg_quote("$40");
	//   returns 1: '\\$40'
	//   example 2: preg_quote("*RRRING* Hello?");
	//   returns 2: '\\*RRRING\\* Hello\\?'
	//   example 3: preg_quote("\\.+*?[^]$(){}=!<>|:");
	//   returns 3: '\\\\\\.\\+\\*\\?\\[\\^\\]\\$\\(\\)\\{\\}\\=\\!\\<\\>\\|\\:'

	return String(str).replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
}

/**
 * Add namespace to all event names
 * @param {string} events string of events separated by spaces
 * @param {string} namespace namespace without '.'
 */
export function namespaceEvents(events, namespace) {
	if (typeof namespace === 'undefined') {
		return events;
	}

	return (events.split(' ').join('.' + namespace + ' ')) + '.' + namespace;
}

/**
 * Create an unique id
 * @return {string} unique id
 */
export function createUniqueId() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
		return v.toString(16);
	});
}

/**
 * Convert a classname / multiple classnames to a valid selector
 * e.g. "en-button en-button--next" to ".en-button.en-button--next"
 * @param  {string} className valid classname(s)
 * @return {string} valid selector based on classname(s)
 */
export function classNamesToSelector(className) {
	var classList = className.split(/[ ]+/);
	var selector = classList.length > 0 ? '.' + classList.join('.') : '';
	return selector;
}
